import firebase from 'firebase/app';
import 'firebase/database'; // If using Firebase database

const config = {
  apiKey: 'AIzaSyDm5bcR5gpUqL3KhPvN1FlklhdgOTgxhbY',
  authDomain: 'trusted-self-dsp.firebaseapp.com',
  databaseURL: 'https://trusted-self-dsp.firebaseio.com',
  projectId: 'trusted-self-dsp',
  storageBucket: 'trusted-self-dsp.appspot.com',
  messagingSenderId: '113966415910',
  appId: '1:113966415910:web:bcd0c3d67892822a70a6e7'
};

firebase.initializeApp(config);
const databaseRef = firebase.database().ref();
export const clientsRef = databaseRef.child('clients');
